import {Property} from "../../../../../models/Property";
import {useTranslation} from "react-i18next";
import {IconButton, makeStyles, TextField} from "@material-ui/core";
import {Add as AddIcon, Remove} from "@material-ui/icons";
import {CustomInputContainer} from "../../PropertyForm";
import {preventNonDigitSymbolInput, removeLeadingZeros} from "../../../../../utils/functions";
import React from "react";
import styled from "@emotion/styled";

const useStyles = makeStyles(() => ({
  customInput: {
    margin: "0px 5px",
  },
  inputDisabled: {
    color: "rgba(255,255,255,0.5)!important",
  },
}));

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  input[type=number]::-webkit-inner-spin-button,
  input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  .MuiOutlinedInput-input {
    padding: 10px 15px;
  }
  .MuiTextField-root {
    margin: 0 5px;
  }
`

const FloorCounterInput = (p: {
  value: number;
  index: number;
  handleChangeCounter: (field: string, value: number, index: number) => void;
  property: Property;
}) => {
  const { value, index, handleChangeCounter, property } = p;
  const styles = useStyles();
  const { t } = useTranslation();
  const isDisabled = false; // property && property.a11y_standard !== "hotel_motel";
  return (
    <Wrapper>
      <IconButton
        onClick={() => (
          handleChangeCounter('level', value - 1, index)
        )}
        size="small"
        disabled={isDisabled}
      >
        <Remove />
      </IconButton>
      <TextField
        label={t("unitForm_floorTitle")}
        name="levels"
        variant="outlined"
        type="number"
        disabled={isDisabled}
        value={removeLeadingZeros(value)}
        onKeyDown={preventNonDigitSymbolInput}
        onChange={(e) => {
          handleChangeCounter(
            'level',
            Number(removeLeadingZeros(e.target.value)),
            index
          );
        }}
        className={`${isDisabled ? styles.inputDisabled : ""} ${
          styles.customInput
        }`}
      />
      <IconButton
        size="small"
        disabled={isDisabled}
        onClick={() => handleChangeCounter('level',value + 1, index)}
      >
        <AddIcon />
      </IconButton>
    </Wrapper>
  );
};

export default FloorCounterInput